module.exports = __webpack_public_path__ + "media/jpg/get-job-offers-pick-2-mob@3x-b4c5eb5c.jpg";